export default __webpack_public_path__ + "static/maglashicc-3f025f497b69c6c3716df0246a6f7424.mp4";